import MCBlock from "../../../../../lib/html5-software-library/src/ranj/eng/content/MCBlock";
import EmailItem from "./EmailItem";

export default class EmailDraftItem extends EmailItem {
    constructor(content, isRead = false, isSent = false) {
        super(content, isRead);

        this.isSent = isSent;
    }

    isCompleted() {
        var incomplete = this.content.getContentBlocks().find(block => block instanceof MCBlock && block.getSelectedOption() == null);
        return incomplete == null;
    }

    send() {
        this.isSent = true;
    }
}